module.exports = __webpack_public_path__ + "static/media/icon-local.2b0679ad.svg";